import { useModal } from 'mui-modal-provider';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { VisionProfileBanner } from '../../user-activity-items/vision-profile-banner';
import { IVisionProfileData } from '../../../../../graphql/profile/models/get-vision-profile.models';
import { GET_VISION_PROFILE } from '../../../../../graphql/profile/queries/get-vision-profile';
import { useVisionProfileData, VPStatus } from '../../../../../hooks/use-vision-profile-data';
import { PreSurveyModal } from '../../vision-profile';
import { InternalLinks } from '../../../../../constants';

export const VisionProfile = (): JSX.Element => {
  const { data } = useQuery<IVisionProfileData>(GET_VISION_PROFILE);
  const { showModal } = useModal();
  const { status, surveySteps } = useVisionProfileData(data);

  const navigate = useNavigate();
  const onConfirm = () => {
    navigate(InternalLinks.visionProfileSurvey, { state: { hasPreviousLocation: true } });
  };


  const handleButtonClick = () => {
    showModal(PreSurveyModal, { surveySteps, onConfirm });
  };

  return (
    <>
      {status === VPStatus.INCOMPLETE && (
        <VisionProfileBanner
          onButtonClick={handleButtonClick}
        />
      )}
    </>
  );
};
